module.exports = __webpack_public_path__ + "fonts/journal.e91c38e6.woff";